export default class ClientListController {
    constructor(clientService, userService, authenticationService, channelsService, $location, globalConstants) {
        this.authenticationService = authenticationService;
        this.$location = $location;
        this.globalConstants = globalConstants;
        clientService.getAll().then(resp => {
            this.clients = resp.data;
        });
        userService.getTrainersBySubscriptionId().then(resp => {
            this.users = resp.data;
        });
        channelsService.getBySubscriptionId().then(resp => {
            this.channels = resp.data;
        });
    }
    editChannel(id){
        this.$location.path("/manage/channels/" + id);
     }
}


// WEBPACK FOOTER //
// ./src/js/components/clients/clients.list.controller.js